import { COLORS } from '@/styles/color';
import { hexToRGBA } from '@/styles/color/utils';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  ${mediaBreakpointUp('tablet')} {
    grid-row: 1;
    padding-right: ${remCalc(20)};
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  row-gap: ${remCalc(30)};

  ${mediaBreakpointUp('tablet')} {
    display: grid;
    grid-template-rows: min-content 1fr;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }
`;

export const Header = styled.p`
  ${customTextSize(14, 18)}
  font-weight: ${FONT_WEIGHTS.BOLD};
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const Column = styled.ul`
  border: 2px solid ${hexToRGBA(COLORS.GRAY.BASE, 0.2)};
  border-radius: ${remCalc(10)};

  li:not(:last-child) {
    border-bottom: 2px solid;
    border-color: inherit;
  }

  ${mediaBreakpointUp('tablet')} {
    flex: 1;
    display: grid;
    grid-auto-rows: 1fr;
    grid-row: 2;
    border-radius: 0;
    border-left-width: 0;

    &[data-first-column] {
      border-left-width: 2px;
      border-top-left-radius: ${remCalc(10)};
      border-bottom-left-radius: ${remCalc(10)};
    }

    &[data-last-column] {
      border-top-right-radius: ${remCalc(10)};
      border-bottom-right-radius: ${remCalc(10)};
    }
  }
`;

export const Row = styled.li`
  padding: ${remCalc(20)};
  display: flex;
  align-items: flex-start;

  svg {
    flex-shrink: 0;
    margin-top: ${remCalc(5)};
    margin-right: ${remCalc(10)};
  }

  p {
    ${customTextSize(16, 24)};
  }

  ${mediaBreakpointUp('desktop')} {
    svg {
      margin-top: ${remCalc(7)};
    }

    p {
      ${customTextSize(18, 26)};
    }
  }
`;
